(function () {
  "use strict";

  function titleFromSlug(href) {
    try {
      var m = (href || "").split("/products/")[1];
      if (!m) return null;
      m = m.split("?")[0].split("#")[0].replace(/^reviv-/, "").replace(/-/g, " ").trim();
      if (!m) return null;
      return m.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    } catch (e) { return null; }
  }

  function fixBreadcrumbs() {
    document.querySelectorAll(".breadcrumbs:not([data-a11y-fixed])").forEach(function (bc) {
      if (bc.closest("nav")) { bc.setAttribute("data-a11y-fixed", "true"); return; }
      var nav = document.createElement("nav");
      nav.setAttribute("aria-label", "Breadcrumb");
      bc.parentNode.insertBefore(nav, bc);
      nav.appendChild(bc);
      bc.setAttribute("data-a11y-fixed", "true");
      var crumbs = bc.querySelectorAll("a, span");
      if (crumbs.length > 0) {
        var last = crumbs[crumbs.length - 1];
        if (last && !last.hasAttribute("aria-current")) last.setAttribute("aria-current", "page");
      }
    });
  }

  function fixProductLinks() {
    document.querySelectorAll('a[href*="/products/"]:not([data-a11y-plink])').forEach(function (link) {
      var hasText = (link.textContent || "").replace(/\s+/g, " ").trim().length > 0;
      var hasAriaLabel = link.getAttribute("aria-label");
      if (!hasText && !hasAriaLabel) {
        var img = link.querySelector("img");
        var scope = link.closest(".card") || link.closest("[class*='gallery__item']") || link.parentElement;
        var titleEl = scope ? scope.querySelector(".card__heading, .card__title, h2, h3") : null;
        var name = (titleEl && titleEl.textContent.trim()) ||
                   (img && img.alt && img.alt.trim()) ||
                   titleFromSlug(link.getAttribute("href")) ||
                   "View product";
        link.setAttribute("aria-label", name);
      }
      link.setAttribute("data-a11y-plink", "true");
    });
  }

  function fixEmptyLinks() {
    var hrefLabels = [
      { m: "/cart", label: "Cart" },
      { m: "/account", label: "Account" },
      { m: "/search", label: "Search" },
      { m: "/collections", label: "Shop" },
      { m: "/pages/contact", label: "Contact" }
    ];
    document.querySelectorAll("a:not([data-a11y-link])").forEach(function (a) {
      var text = (a.textContent || "").replace(/\s+/g, " ").trim();
      var hasLabel = a.getAttribute("aria-label");
      var img = a.querySelector("img");
      var imgAlt = img && img.getAttribute("alt");
      if (!text && !hasLabel && !imgAlt) {
        var cls = (a.className || "").toString();
        var href = (a.getAttribute("href") || "").toLowerCase();
        var label = null;
        if (/close/.test(cls) || /__close/.test(cls)) {
          label = /newsletter|popup|notification/.test(cls) ? "Close newsletter popup" : "Close";
        }
        if (!label) {
          for (var i = 0; i < hrefLabels.length; i++) {
            if (href.indexOf(hrefLabels[i].m) !== -1) { label = hrefLabels[i].label; break; }
          }
        }
        if (label) a.setAttribute("aria-label", label);
      }
      a.setAttribute("data-a11y-link", "true");
    });
  }

  function fixMissingImageAlt() {
    document.querySelectorAll("img:not([alt])").forEach(function (img) {
      img.setAttribute("alt", "");
    });
  }

  function fixSocialIcons() {
    var socialMap = {
      "facebook": "Facebook", "instagram": "Instagram", "pinterest": "Pinterest",
      "twitter": "Twitter", "x.com": "X (Twitter)", "youtube": "YouTube",
      "tiktok": "TikTok", "linkedin": "LinkedIn"
    };
    document.querySelectorAll("a[href]:not([aria-label]):not([data-a11y-social])").forEach(function (a) {
      var href = a.href.toLowerCase();
      var text = (a.textContent || "").replace(/\s+/g, "").length;
      if (text === 0) {
        for (var key in socialMap) {
          if (href.indexOf(key) !== -1) { a.setAttribute("aria-label", socialMap[key]); break; }
        }
      }
      a.setAttribute("data-a11y-social", "true");
    });
  }

  function runAll() {
    try { fixBreadcrumbs(); } catch (e) { console.warn("a11y breadcrumbs:", e); }
    try { fixProductLinks(); } catch (e) { console.warn("a11y product links:", e); }
    try { fixSocialIcons(); } catch (e) { console.warn("a11y social:", e); }
    try { fixEmptyLinks(); } catch (e) { console.warn("a11y empty links:", e); }
    try { fixMissingImageAlt(); } catch (e) { console.warn("a11y img-alt:", e); }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAll);
  } else {
    runAll();
  }

  var observer = new MutationObserver(function () { runAll(); });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();